import { CircularProgress } from '@material-ui/core'
import React from 'react'
import { useStyles } from './ScreenLoader.styles'

export const ScreenLoader = () => {
  const classes = useStyles()
  return (<div className={classes.loadingWrapper}><CircularProgress aria-label="Loading" /></div>)
}
